@if (product$ | async; as product) {
  <div
    class="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/80 backdrop-blur-md modal-overlay"
    (click)="closeModal()"
  >
    <div
      @modalAnimation
      (click)="$event.stopPropagation()"
      class="relative w-full sm:max-w-4xl max-h-[90dvh] sm:max-h-[85vh] bg-obsidian-surface rounded-t-3xl sm:rounded-2xl shadow-gold-glow border border-champagne-gold/20 text-silk-ivory flex flex-col"
    >
      <!-- Botón de Cerrar -->
      <button
        (click)="closeModal()"
        class="absolute top-4 right-4 z-20 text-silk-ivory/60 hover:text-champagne-gold transition"
      >
        <svg
          class="w-7 h-7"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <!-- Insignia Superior Alta Perfumería -->
      <div class="px-6 sm:px-8 pt-6 pb-2 border-b border-champagne-gold/10 flex items-center justify-between">
        <span class="text-xs uppercase tracking-[0.25em] text-champagne-gold font-semibold">Altair Parfum • Haute Parfumerie</span>
        <span class="text-xs tracking-wider text-silk-ivory/50">Edición Coleccionista</span>
      </div>

      <!-- Contenido Principal Scrollable -->
      <div
        class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 overflow-y-auto p-6 sm:p-8 pb-[120px] sm:pb-8"
      >
        <!-- Columna de Imagen -->
        <div
          class="w-full aspect-square max-h-64 sm:max-h-full sm:aspect-auto flex items-center justify-center self-start sm:sticky sm:top-0 bg-obsidian rounded-xl p-4 border border-champagne-gold/10"
        >
          <img
            [src]="product.urlImage"
            [alt]="product.name"
            class="w-full h-full object-contain rounded-lg drop-shadow-2xl"
          />
        </div>
        <!-- Columna de Detalles -->
        <div class="flex flex-col mt-4 sm:mt-0">
          <h2 class="text-3xl sm:text-4xl font-serif font-bold mb-2 leading-tight text-silk-ivory">
            {{ product.name }}
          </h2>
          <p class="text-champagne-gold/80 text-xs uppercase tracking-widest mb-4">Concentración: Extracto de Perfume (30%)</p>
          <p class="text-champagne-gold font-serif font-semibold text-3xl sm:text-4xl my-2">
            {{ product.price | currency: "$" : "symbol" : "1.0-0" }}
          </p>

          <!-- Nota de Muestra de Cortesía -->
          <div class="my-3 p-3 rounded-lg bg-champagne-gold/5 border border-champagne-gold/20 flex items-center gap-3">
            <svg class="w-5 h-5 text-champagne-gold flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            <span class="text-xs text-silk-ivory/90 font-medium">Incluye muestra de cortesía de 2ml para prueba en piel.</span>
          </div>

          <div class="space-y-4 mt-2">
            <h3 class="text-sm font-semibold tracking-wider uppercase text-champagne-gold border-b border-champagne-gold/20 pb-2">
              Notas Olfativas & Descripción
            </h3>
            <p class="text-silk-ivory/80 text-sm leading-relaxed">
              {{ product.description }}
            </p>
          </div>
        </div>
      </div>
      <!-- Footer Fijo/Estático para Acciones -->
      <div
        class="absolute bottom-0 left-0 w-full mt-auto p-4 bg-obsidian-surface/90 backdrop-blur-md border-t border-champagne-gold/20 sm:static sm:p-6 sm:border-none sm:bg-transparent"
      >
        <div class="max-w-md mx-auto sm:max-w-full sm:px-2 sm:pb-0">
          <div class="flex items-center gap-4">
            <div class="flex items-center border border-champagne-gold/30 rounded-full bg-obsidian">
              <button
                (click)="decrementQuantity()"
                [disabled]="quantity <= 1"
                class="px-4 py-2 text-silk-ivory/70 hover:bg-champagne-gold/10 rounded-l-full transition disabled:opacity-50"
              >
                -
              </button>
              <span class="px-5 py-2 font-semibold text-lg text-silk-ivory">{{
                quantity
              }}</span>
              <button
                (click)="incrementQuantity()"
                class="px-4 py-2 text-silk-ivory/70 hover:bg-champagne-gold/10 rounded-r-full transition"
              >
                +
              </button>
            </div>
            <button
              (click)="addToCart()"
              appGalaxyButton
              appGalaxyRipple
              galaxyVariant="primary"
              class="flex-1 !bg-champagne-gold !text-obsidian font-bold hover:!bg-champagne-gold-light"
            >
              Añadir al Cofre
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

